module.exports = __webpack_public_path__ + "static/rf-screenshot-profile-44c6645f3cc9a2f326ef3925658bdd09.jpg";